import type { EffectCallback } from 'react';
import { useEffect, useRef } from 'react';

export const useUpdateEffect = (effect: EffectCallback, dependencies: unknown[]) => {
  const isFirstMount = useRef(true);

  useEffect(() => {
    if (isFirstMount.current) {
      isFirstMount.current = false;
      return () => {}; // eslint-disable-line @typescript-eslint/no-empty-function
    }

    return effect();
  }, dependencies); // eslint-disable-line react-hooks/exhaustive-deps
};
